import { lazy, memo } from 'react'
import { Navigate, useRoutes } from 'react-router-dom'

import pathName from './pathName.constant'
import ProtectedRoute from './PrivateRoute'
import BulkUpload from '../components/jobs/presentation/BulkUpload/presentation'
import PublicLayout from '../components/layout/presentation/PublicLayout'
import PageNotFound from '../components/PageNotFound'
import Report from '../components/report/presentation'
import UserManagement from '../components/userManagement/presentation'

const AppLayout = lazy(
  () => import('../components/layout/presentation/AppLayout'),
)
const SearchReactFlow = lazy(
  () => import('../components/dashboard/presentation/SearchReactFlow'),
)
const Auth = lazy(() => import('../components/layout/presentation'))
const PublicVehicleDetails = lazy(
  () => import('../components/inventory/presentation/PublicVehicleDetails'),
)
const PublicJobDetails = lazy(
  () => import('../components/jobs/presentation/PublicJobDetails'),
)
const Home = lazy(() => import('../components/home/presentation'))
const Dashboard = lazy(() => import('../components/dashboard/presentation'))
const DashboardStats = lazy(
  () => import('../components/dashboard/presentation/DashBoardStats'),
)
const DashboardIndia = lazy(
  () => import('../components/dashboard/presentation/DashboardIndia'),
)
const LiveBoard = lazy(() => import('../components/liveboard/presentation'))
const DataVisualization = lazy(
  () => import('../components/dataVisualization/presentation'),
)
const AuthAddUser = lazy(
  () => import('../components/userManagement/presentation/AuthAddUser'),
)
const Profile = lazy(() => import('../components/profile/presentation/index'))
// const CatalogueManagement = lazy(
//   () => import('../components/catalogueManagement/presentation'),
// )
const AddEditJobs = lazy(
  () => import('../components/jobs/presentation/addJobs'),
)
const JobManagement = lazy(() => import('../components/jobs/presentation'))
const Inventory = lazy(() => import('../components/inventory/presentation'))
const ViewVehicle = lazy(
  () => import('../components/inventory/presentation/ViewVehicle'),
)
const ViewParts = lazy(
  () => import('../components/inventory/presentation/ViewParts'),
)
const BucketManagement = lazy(
  () => import('../components/bucketManagement/presentation'),
)
const CategoryManagement = lazy(
  () => import('../components/categoryManagement/presentation'),
)
const Settings = lazy(() => import('../components/settings/presentation'))
const TraceabilityHtml = lazy(
  () => import('../components/layout/presentation/TraceabilityHtml'),
)
const Routing = () => {
  const routes = useRoutes([
    {
      path: pathName.ROOT,
      element: (
        <ProtectedRoute>
          <AppLayout />
        </ProtectedRoute>
      ),
      children: [
        {
          index: true,
          element: <Navigate to={pathName.HOME} replace={true} />,
        },
        {
          path: pathName.HOME,
          element: <Home />,
        },
        {
          path: pathName.DASHBOARD,
          element: <Dashboard />,
        },
        {
          path: pathName.DASHBOARD_COMPLIANCE,
          element: <Dashboard />,
        },
        {
          path: pathName.SEARCH_REACT_FLOW,
          element: <SearchReactFlow />,
        },
        {
          path: pathName.DASHBOARD_STATS,
          element: <DashboardStats />,
        },
        {
          path: pathName.DASHBOARD_INDIA,
          element: <DashboardIndia />,
        },
        {
          path: pathName.USER,
          element: <UserManagement />,
        },
        {
          path: pathName.DATA_VISUALIZATION,
          element: <DataVisualization />,
        },
        {
          path: pathName.ADD_USER,
          element: <AuthAddUser />,
        },
        {
          path: pathName.PROFILE,
          element: <Profile />,
        },
        {
          path: pathName.JOBS,
          element: <JobManagement />,
        },
        {
          path: pathName.INVENTORY,
          element: <Inventory />,
        },
        {
          path: pathName.ADD_JOB,
          element: <AddEditJobs />,
        },
        {
          path: pathName.EDIT_JOB,
          element: <AddEditJobs />,
        },
        {
          path: pathName.VEHICLE_DETAILS,
          element: <ViewVehicle />,
        },
        {
          path: pathName.PART_DETAILS,
          element: <ViewParts />,
        },
        {
          path: pathName.BUCKET_MANAGEMENT,
          element: <BucketManagement />,
        },
        {
          path: pathName.CATEGORY_MANAGEMENT,
          element: <CategoryManagement />,
        },
        {
          path: pathName.REPORT,
          element: <Report />,
        },
        {
          path: pathName.LIVE_BOARD_PATH,
          element: <LiveBoard />,
        },
        {
          path: pathName.SETTINGS,
          element: <Settings />,
        },
        {
          path: pathName.BULK_UPLOAD,
          element: <BulkUpload />,
        },
        {
          path: pathName.TRACE_SAMPLE,
          element: <TraceabilityHtml type="sample" />,
        },
        {
          path: pathName.TRACE_ACTUAL,
          element: <TraceabilityHtml type="actual" />,
        },
        {
          path: pathName.PLASTIC_TRACE_SAMPLE,
          element: <TraceabilityHtml type="plastic" />,
        },
        {
          path: pathName.PLASTIC_TRACE_ACTUAL,
          element: <TraceabilityHtml type="plasticActual" />,
        },
        {
          path: pathName.TRACE_END_TO_END,
          element: <TraceabilityHtml type="endToEnd" />,
        },
        {
          path: pathName.TRACE_END_TO_END2,
          element: <TraceabilityHtml type="endToEnd2" />,
        },
        {
          path: pathName.VEHICLE_SALES,
          element: <TraceabilityHtml type="vehicleSales" />,
        },
        { path: '*', element: <PageNotFound /> },
      ],
    },
    { path: pathName.LOGIN, element: <Auth /> },
    { path: pathName.FORGOT_PASSWORD, element: <Auth /> },
    {
      path: pathName.PUBLIC_VEHICLE_DETAILS,
      element: <PublicVehicleDetails />,
    },
    {
      path: pathName.PUBLIC_JOB_DETAILS,
      element: (
        <PublicLayout>
          <PublicJobDetails />
        </PublicLayout>
      ),
    },
  ])

  return routes
}

export default memo(Routing)
